<template>
  <div>
    <!--기본정보-->
    <field-select-module v-model="form.stdInfo" :board="this.board" :is-print="isPrint" />

    <!--협의체 정보-->
    <div class="mt-28px">
      <h5 class="mb-4"><i class="dot"></i> 협의체 정보</h5>
      <div class="writeGridContainer">
        <div>
          <div>구분</div>
          <p v-if="isPrint" class="print-input">{{ form.inputA_1 }}</p>
          <vs-select v-model="form.inputA_1" autocomplete v-else :readonly="board.readonly">
            <vs-select-item text="최초" value="최초" />
            <vs-select-item text="정기" value="정기" />
            <vs-select-item text="수시" value="수시" />
          </vs-select>
        </div>
        <div>
          <div>협의일</div>
          <p v-if="isPrint" class="print-input">{{ form.inputA_2 }}</p>
          <date-selector v-else v-model="form.inputA_2" :readonly="board.readonly" />
        </div>
        <div>
          <div>차수</div>
          <p v-if="isPrint" class="print-input">{{ form.inputA_3 }}</p>
          <comma-input v-else :readonly="board.readonly" />
        </div>
        <div>
          <div>대상기간</div>
          <p v-if="isPrint" class="print-input">{{ form.inputA_4 }} ~ {{ form.inputA_5 }}</p>
          <div v-else class="time">
            <date-selector v-model="form.inputA_4" :readonly="board.readonly" />
            <p>~</p>
            <date-selector v-model="form.inputA_5" :readonly="board.readonly" />
          </div>
        </div>
      </div>
    </div>

    <!-- 위험성평가협의회(사용자) -->
    <table-custom
      :board="board"
      :is-print="isPrint"
      title="위험성평가협의회(사용자)"
      :tableData="[
        { id: 'cell1', title: '소속명', type: 'text' },
        { id: 'cell2', title: '직책', type: 'select', selectData: ['사용자대표', '안전관리자', '보건관리자', '관리감독자', '사용자위원', '기타'] },
        { id: 'cell3', title: '이름', type: 'text' },
        { id: 'cell4', title: '서명', type: 'sign' },
        { id: 'cell5', title: '비고', type: 'text' },
      ]"
      :mobile="['cell1', 'cell3']"
      v-model="form.userTableList"
      class="mt-28px"
    />

    <!-- 위험성평가협의회(근로자) -->
    <table-custom
      :board="board"
      :is-print="isPrint"
      title="위험성평가협의회(근로자)"
      :tableData="[
        { id: 'cell1', title: '소속명', type: 'text' },
        { id: 'cell2', title: '직책', type: 'select', selectData: ['근로자대표', '명예산업안전감독관', '근로자위원', '기타'] },
        { id: 'cell3', title: '이름', type: 'text' },
        { id: 'cell4', title: '서명', type: 'sign' },
        { id: 'cell5', title: '비고', type: 'text' },
      ]"
      :mobile="['cell1', 'cell3']"
      v-model="form.userTableList"
      class="mt-28px"
    />

    <!-- 협의내용 -->
    <div class="mt-28px">
      <h5 class="mb-4"><i class="dot"></i> 협의내용</h5>

      <div class="writeGridContainer">
        <div style="grid-column: span 6 / span 12">
          <div>재해형태(필수)</div>
          <p v-if="isPrint" class="print-input">{{ form.inputB_1 }}</p>
          <disaster-class-selector v-else v-model="form.inputB_1" :readonly="board.readonly" />
        </div>
        <div style="grid-column: span 6 / span 12">
          <div>전회 미결사항</div>
          <span v-if="isPrint" class="print-textarea"> {{ form.inputB_2 }} </span>
          <ml-textarea v-else rows="5" v-model="form.inputB_2" :readonly="board.readonly" />
        </div>
        <div class="writeGridLineItem">
          <div>전회 우수사례</div>
          <span v-if="isPrint" class="print-textarea"> {{ form.inputB_3 }} </span>
          <ml-textarea v-else rows="5" v-model="form.inputB_3" :readonly="board.readonly" />
        </div>
        <div class="writeGridLineItem">
          <div>근로자 의견</div>
          <span v-if="isPrint" class="print-textarea"> {{ form.inputB_4 }} </span>
          <ml-textarea v-else rows="5" v-model="form.inputB_4" :readonly="board.readonly" />
        </div>
        <div class="writeGridLineItem">
          <div>경영자 의견</div>
          <span v-if="isPrint" class="print-textarea"> {{ form.inputB_5 }} </span>
          <ml-textarea v-else rows="5" v-model="form.inputB_5" :readonly="board.readonly" />
        </div>
        <div class="writeGridLineItem">
          <div>위험요인 추가</div>
          <span v-if="isPrint" class="print-textarea"> {{ form.inputB_6 }} </span>
          <ml-textarea v-else rows="5" v-model="form.inputB_6" :readonly="board.readonly" />
        </div>
      </div>
    </div>

    <!-- 사진대지 -->
    <photo-upload-grid-module :row-count="2" :grid-count="2" v-model="form.photoList" :is-print="isPrint" :readonly="board.readonly" section-title="사진대지" placeholder="점검 현장 사진" class="mt-28px" />

    <!--    파일첨부-->
    <file-upload-module v-model="form.fileL10ist" :is-print="isPrint" :readonly="board.readonly" class="mt-28px"></file-upload-module>
  </div>
</template>

<script>
import FieldSelectModule from "@/views/modules/FieldSelectModule";
import DateSelector from "@/components/selector/DateSelector";
import PhotoUploadGridModule from "@/views/modules/PhotoUploadGridModule";
import FileUploadModule from "@/views/modules/FileUploadModule";
import DisasterClassSelector from "@/components/selector/DisasterClassSelector";
import SignField from "@/components/SignField";
import TableCustom from "@/components/TableCustom";

export default {
  components: {
    SignField,
    FieldSelectModule,
    DateSelector,
    PhotoUploadGridModule,
    FileUploadModule,
    DisasterClassSelector,
    TableCustom,
  },
  props: {
    isPrint: Boolean,
    board: Object,
    value: Object,
  },
  watch: {
    value: {
      immediate: true,
      deep: true,
      handler(value) {
        const keys = Object.keys(this.form);
        for (const key of keys) {
          if (value[key]) {
            this.form[key] = value[key];
            if (key === "userTableList" && 0 < value[key].length) this.userTempId = value[key][value[key].length - 1].id;
            if (key === "workerTableList" && 0 < value[key].length) this.workerTempId = value[key][value[key].length - 1].id;
          }
        }
      },
    },
    form: {
      immediate: true,
      deep: true,
      handler(value) {
        this.$emit("input", value);
      },
    },
  },
  data() {
    return {
      form: {
        stdInfo: {},
        userTableList: [],
        workerTableList: [],
        inputA_1: "",
        inputA_2: "",
        inputA_3: "",
        inputA_4: "",
        inputA_5: "",
        inputB_1: "",
        inputB_2: "",
        inputB_3: "",
        inputB_4: "",
        inputB_5: "",
        inputB_6: "",
        photoList: [],
        fileList: [],
      },
      userSelected: [],
      workerSelected: [],
      userTempId: 0,
      workerTempId: 0,
    };
  },
  methods: {
    addTableRow(type) {
      this.form[type].push({
        id: type === "userTableList" ? ++this.userTempId : ++this.workerTempId,
        cell1: "",
        cell2: "",
        cell3: "",
        cell4: "",
        cell5: "",
      });
    },
    deleteSelectTable(type) {
      const seletedIds = type === "userTableList" ? this.userSelected.map((item) => item.id) : this.workerSelected.map((item) => item.id);
      this.form[type] = this.form[type].filter((item) => !seletedIds.includes(item.id));
    },
    comma(num) {
      const str = `${Number(num) ? Number(num) : ""}`;
      if (str && str.length > 0) {
        return str.replace(/,/gi, "").replace(/\B(?=(\d{3})+(?!\d))/gi, ",");
      }
      return str;
    },
    removeComma(str) {
      return str.replace(/,/g, "");
    },
  },
};
</script>

<style scoped lang="scss">
$border: 1px solid #cdcdcd;
.label-text {
  width: 114px;
  font-weight: 500;
  font-size: 14px;
}

.mt-component-form {
  margin-top: 15px;
}

/* uploaded File */
.h-upload {
  height: 470px;
}

.upload-content {
  border: $border;

  &:last-child {
    border-left: none;
  }

  &__title {
    height: 54px;
    line-height: 54px;
    text-align: center;
    background: #fafafa;
    border-bottom: $border;
  }

  &__input {
    height: 54px;
    background: #f9f9f9;
    border-top: $border;
    padding: 5px 15px;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  &__file {
    height: calc(100% - 54px);
    width: 100%;
    padding: 14px;
  }
}

.table ::v-deep {
  .vs-con-tbody {
    background: none !important;
    border: 0 !important;
  }
  thead tr {
    background: #f9f9f9 !important;
    border-top: solid 1px #cdcdcd;
    border-bottom: solid 1px #cdcdcd;
  }
  tr {
    background: #fff !important;
    border-bottom: solid 1px #cdcdcd;
  }
}
</style>
